// Chakra imports
import { Box, Flex } from '@chakra-ui/react';
// Custom components
import DefaultAuth from 'layouts/auth/Default';
// Assets
import Footer from 'components/footer/FooterAuth';
import { getVariable } from 'whitelabel';
import LoginInputs from './LoginInputs';

function SignIn() {
  return (
    <DefaultAuth
      illustrationBackground={getVariable('banner')}
      image={getVariable('banner')}
    >
      <Flex
        maxW={{ base: '100%', md: '40%' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        my={{ base: 'auto', lg: '150' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: '30px', md: '30px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '0', md: '4vh' }}
        flexDirection="column"
      >
        <LoginInputs />
        <Box mt={10}></Box>
        <Footer />
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
